import { isDesktop } from 'react-device-detect';
import FreespinPromptController from '../../controllers/freespin/FreespinPromptController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { FreespinPromptGrid } from './FreespinPromptGrid';
let scale = isDesktop ? 1 : 2;
export const FreespinPromptView = {
	name: COMPONENTS.FREESPIN_PROMPT,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: FreespinPromptController,
			name: 'FreespinPromptController',
			config: {
				holder: 'freespin_prompt_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'PromptGridController',
			config: FreespinPromptGrid
		}
	],
	components: [
		{
			name: 'freespin_prompt_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'external_bonus_bg',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'FREE_SPIN_HEADER',
					position: { x: 634 / 2, y: 18 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_TIME_FRAME_WRAPPER',
					type: 'Sprite',
					position: {
						x: 495,
						y: 73
					},
					components: [
						{
							name: 'FREE_SPIN_TIME_FRAME',
							type: 'Sprite',
							img: 'time_frame',
							position: {
								x: 0,
								y: 0
							},
							scale: {
								x: 1.5,
								y: 1.5
							}
						},
						{
							name: 'FREE_SPIN_TIME_TEXT',
							type: 'Text',
							text: 'FREE_SPIN_TIME_TEXT',
							position: { x: 144 / 2, y: 5 },
							anchor: { x: 0.5, y: 0 }
						},
						{
							name: 'FREE_SPIN_TIME',
							type: 'Text',
							text: 'FREE_SPIN_TIME',
							position: { x: 144 / 2, y: 27 },
							anchor: { x: 0.5, y: 0 }
						}
					]
				},
				{
					name: 'FREE_SPIN_TITLE',
					type: 'Text',
					text: 'FREE_SPIN_TITLE',
					position: { x: 634 / 2, y: 150 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_PRIZE',
					type: 'CustomText',
					text: 'FREE_SPIN_PRIZE',
					position: { x: 634 / 2 + 10, y: 210 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_INFO',
					type: 'Text',
					text: 'FREE_SPIN_INFO',
					position: { x: 634 / 2, y: 300 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_PLAY_NOW',
					type: 'ActionButton',
					bg: 'external_bonus_play_now_btn',
					text: 'FREE_SPIN_PLAY_NOW',
					position: { x: 180, y: 500 }
				},
				{
					name: 'FREE_SPIN_PLAY_LATER',
					type: 'ActionButton',
					bg: 'external_bonus_play_later_btn',
					text: 'FREE_SPIN_PLAY_LATER',
					position: { x: 452, y: 500 }
				}
			]
		}
	]
};
